import culture from "../constants/culture-codes";

const isDanish = (cultureCode: string | null | undefined): boolean =>
  cultureCode === culture.danish;

const isEnglish = (cultureCode: string | null | undefined): boolean =>
  cultureCode === culture.english;

const isFinnish = (cultureCode: string | null | undefined): boolean =>
  cultureCode === culture.finnish || cultureCode === culture.swedishFinland;

const isNorwegian = (cultureCode: string | null | undefined): boolean =>
  cultureCode === culture.norwegian;

const isSwedish = (cultureCode: string | null | undefined): boolean =>
  cultureCode === culture.swedish;

export { isDanish, isEnglish, isFinnish, isNorwegian, isSwedish };
